// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v7CnF","toggle":"styles_toggle__1k-gu","preview":"styles_preview__gLUST"};